import { render, staticRenderFns } from "./addDevice.vue?vue&type=template&id=c96b089a&scoped=true"
import script from "./addDevice.vue?vue&type=script&lang=js"
export * from "./addDevice.vue?vue&type=script&lang=js"
import style0 from "./addDevice.vue?vue&type=style&index=0&id=c96b089a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96b089a",
  null
  
)

export default component.exports